import React from "react";
import LoadingAnimation from "../components/LoadingAnimation/LoadingAnimation";

export default function LoadingPage() {
  return (
    <div style={{ minHeight: "100vh" }}>
      <LoadingAnimation fullScreen />
    </div>
  );
}
